import {
  CountryDetailNode,
  CountryDetailsResponse,
  NormalizedCountryDetail,
} from "@/app/shared-components/country-change-modal/types/country-change-modal-types";

export function normalizeCountryDetails(
  raw: CountryDetailsResponse | undefined
): NormalizedCountryDetail[] {
  if (!raw) return [];

  return Object.values(raw)
    .filter((item): item is CountryDetailNode => {
      return typeof item === "object" && "countryText" in item;
    })
    .map((item) => ({
      countryText: item.countryText,
      countryLanguage: item.countryLanguage,
      countryFlag:
        typeof item.countryFlag === "string"
          ? {
              "@id": "",
              "@link": item.countryFlag,
              "@name": "",
              "@path": "",
              "@type": "",
              "@uuid": "",
            }
          : item.countryFlag ?? null,
      redirectUrl: item.redirectUrl ?? "",
      isDefault: item.isDefault ?? false,
    }));
}

export function findDefaultCountry(
  countries: NormalizedCountryDetail[]
): NormalizedCountryDetail | null {
  return countries.find((country) => country.isDefault) ?? null;
}
